import type { Currency } from '../../../constants';
import type { ShippingPolicyItem } from '../../../model/siteconfig/siteconfig';

export interface GetShippingPoliciesResponse {
  /** Configuration key */
  key: string;
  /** Configuration version (timestamp in seconds) */
  version: number;
  /** Array of shipping policies by country */
  config: ShippingPolicyItem[];
}

export interface GetShippingPolicyRequest {
  /** Currency code to fetch shipping policy for */
  currency: Currency;
}

export type GetShippingPolicyResponse = ShippingPolicyItem;
